import { render, staticRenderFns } from "./zgc.vue?vue&type=template&id=5fbd11ab&scoped=true&"
import script from "./zgc.vue?vue&type=script&lang=js&"
export * from "./zgc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd11ab",
  null
  
)

export default component.exports